var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"breadcrumbs-container section-container",class:{'dark':_vm.skinType}},[_c('el-breadcrumb',{attrs:{"separator-class":"el-icon-arrow-right"}},_vm._l((_vm.breadcrumbs),function(breadcrumb,index){return _c('el-breadcrumb-item',{key:'breadcrumb' + index,attrs:{"to":{
        path: breadcrumb.routeName,
        params: {
          equipId: '',
        },
      },"replace":true}},[_vm._v(" "+_vm._s(breadcrumb.title))])}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }